"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var button_1 = __importDefault(require("../atoms/button"));
function buttonProp(action, overrides) {
    if (overrides === void 0) { overrides = {}; }
    if (!action) {
        return null;
    }
    if (action.type === button_1.default) {
        return React.cloneElement(action, overrides);
    }
    if (typeof action === 'object') {
        return (React.createElement(button_1.default, __assign({ icon: action.icon, onClick: action.handler }, overrides), action.label));
    }
    throw new Error('button prop must be object or type Button');
}
exports.default = buttonProp;
//# sourceMappingURL=button-prop.js.map